import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from 'src/app/core/services/auth.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { environment } from 'src/environments/environment';
//import { ApprovalService } from "src/app/modules/pricing-assistant/services/approval.service";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  activeNotification: any;
  labels: any;
  user = '';
  userProfile: any;

  constructor(
    private authService: AuthService,
    private auth: AuthService,
    public dialog: MatDialog,
    private localService: LocalStorageService,
    private keycloakService: KeycloakService
  ) {}

  ngOnInit(): void {
    this.initializeUserOptions();
    this.authService.currentNotification.subscribe((notification) => {
      this.activeNotification = notification;
      console.log(" Ticket initialized");
      this.keycloakService.loadUserProfile().then(data => console.log(data.firstName));
    });
    this.keycloakService.loadUserProfile().then(profile => {
      this.userProfile = profile;
    });
  }

  private initializeUserOptions(): void {
    this.user = this.keycloakService.getUsername();
    this.user = this.capitalizeFirstLetter(this.user);
  }
  onLogout(e: any) {
    e.preventDefault();
    e.stopPropagation();
    this.keycloakService.logout(environment.url);
  }
  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

}
